module.exports = __webpack_public_path__ + "static/media/newsletter-july-2019-manton-retreat.17f4a0d0.jpg";